<ng-container *ngFor="let banner of _banners; index as i">
  <mat-card appearance="outlined" [@fadeIn] [@leaveToLeft]="leaving ? 'out' : 'in'" *ngIf="i === index" [ngClass]="banner.bannerSeverity.code">
    <mat-icon *ngIf="getSeverityIconString(banner)" mat-card-avatar>{{getSeverityIconString(banner)}}</mat-icon>
    <span>{{banner.message}}</span>
    <button *ngIf="shouldShowRefreshButton(banner)" mat-raised-button color="primary" (click)="refresh()">Refresh</button>
    <button *ngIf="!shouldShowRefreshButton(banner)" mat-icon-button (click)="dismissBanner(banner)"><mat-icon>close</mat-icon></button>
  </mat-card>
</ng-container>
